import {AbstractControl, NG_VALIDATORS, Validator, ValidatorFn} from '@angular/forms';
import {timeStampUIRegex} from './time-stamp-formatter';
import {Directive} from '@angular/core';

@Directive({
  selector: '[appTimestampValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: TimestampValidatorDirective, multi: true}]
})
export class TimestampValidatorDirective implements Validator {

  validate(control: AbstractControl): {[key: string]: any} | null {
    return timestampValidator()(control);
  }
}


export function timestampValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const value = control.value;
    if (!timeStampUIRegex.test(value))
      return {'timestampValidator': {requiredPattern: timeStampUIRegex, actualValue: value}};

    const parts = value.split(':');
    if (Number.parseInt(parts[0]) >= 24)
      return {'timestampValidator': {requiredHours: '< 24:00', actualValue: value}};

    return null;
  };
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/components/timestamp-field/timestamp-validator.directive.ts